import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module mention/ui/mentionlistitemview
 */
import ListItemView from '@ckeditor/ckeditor5-ui/src/list/listitemview';

var MentionListItemView =
/*#__PURE__*/
function (_ListItemView) {
  _inherits(MentionListItemView, _ListItemView);

  function MentionListItemView() {
    _classCallCheck(this, MentionListItemView);

    return _possibleConstructorReturn(this, _getPrototypeOf(MentionListItemView).apply(this, arguments));
  }

  _createClass(MentionListItemView, [{
    key: "highlight",
    value: function highlight() {
      var child = this.children.first;
      child.isOn = true;
    }
  }, {
    key: "removeHighlight",
    value: function removeHighlight() {
      var child = this.children.first;
      child.isOn = false;
    }
  }]);

  return MentionListItemView;
}(ListItemView);

export { MentionListItemView as default };